var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem as MuiMenuItem } from '@mui/material';
import Text from '../Text';
import Tooltip from '../Tooltip';
import { useCallback } from 'react';
var MenuItemTooltipWrapper = function (_a) {
    var children = _a.children, tooltipProps = __rest(_a, ["children"]);
    return (_jsx(Tooltip, __assign({ title: tooltipProps.title, placement: tooltipProps.placement, arrow: tooltipProps.arrow }, { children: _jsx("div", { children: children }) })));
};
export default function MenuItem(props) {
    var tooltipProps = props.tooltipProps, label = props.label, value = props.value, _a = props.textColor, textColor = _a === void 0 ? 'slateBase' : _a, onClick = props.onClick, _b = props.disabled, disabled = _b === void 0 ? false : _b, tabIndex = props.tabIndex;
    var onClickMenuItem = useCallback(function () {
        if (onClick)
            onClick(value);
    }, [value, onClick]);
    var menuItem = (_jsx(MuiMenuItem, __assign({ tabIndex: tabIndex, disabled: disabled, onClick: onClickMenuItem }, { children: _jsx(Text, __assign({ variant: "body3", color: textColor }, { children: label })) })));
    if (!tooltipProps)
        return menuItem;
    return _jsx(MenuItemTooltipWrapper, __assign({}, tooltipProps, { children: menuItem }));
}
